import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import InfoComplete from './InfoComplete';
import GenereCsv from './GenereCsv';
import ColumnChooser from './ColumnChooser';
import { cleanJson } from './utils/Columns';
import { FaTimes } from 'react-icons/fa';

const TribuRappro = ({ gotoAuth, annee }) => {

    const url = localStorage.getItem('url');
    const urltribu = "https://webservices.k-lix.com/TribuPrd.aspx?action=getGarageForCrm";
    const code = localStorage.getItem('code');
    const [show, setShow] = useState(false);
    const [showTribu, setShowTribu] = useState(false);
    const [adherentSel, setAdherentSel] = useState({});
    // Filtrer les articles initialisés et non initialisés

    const [searchText, setSearchText] = useState('');
    const [adherents, setAdherents] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);

    const [tribu, setTribu] = useState([]);

    const getTribu = () => {
        fetch(`${urltribu}`)
            .then(response => response.json())
            .then(data => {
                setTribu(data.data);
            })
            .catch(error => console.error('Erreur:', error));
    };

    const joinAllValueOfAnOBjectSeparatedBySpace = (obj) => {
        return Object.values(obj).join(' ');
    }

    const getFiveHighestSimilarities = (crm) => {
        //clone crm
        let mycrm = JSON.parse(JSON.stringify(crm));
        //        mycrm.delete('a_id').delete('t_tribu').delete('merged');
        delete mycrm.a_id;
        delete mycrm.t_tribu;
        delete mycrm.merged;
        const similarities = tribu.map(garage => {
            return {
                garage: garage,
                similarity: calculateSimilarity(joinAllValueOfAnOBjectSeparatedBySpace(mycrm), joinAllValueOfAnOBjectSeparatedBySpace(garage)).similarity
            };
        });

        return similarities.sort((a, b) => b.similarity - a.similarity).slice(0, 10);
    }

    const levenshteinDistance = (string1, string2) => {
        // Créer un tableau de dimensions (string1.length + 1) x (string2.length + 1)
        const distanceMatrix = Array(string1.length + 1).fill(null).map(() => Array(string2.length + 1).fill(null));

        // Initialiser la première colonne du tableau
        for (let i = 0; i <= string1.length; i += 1) {
            distanceMatrix[i][0] = i;
        }

        // Initialiser la première ligne du tableau
        for (let j = 0; j <= string2.length; j += 1) {
            distanceMatrix[0][j] = j;
        }

        for (let i = 1; i <= string1.length; i += 1) {
            for (let j = 1; j <= string2.length; j += 1) {
                const indicator = string1[i - 1] === string2[j - 1] ? 0 : 1;
                distanceMatrix[i][j] = Math.min(
                    distanceMatrix[i][j - 1] + 1, // Insert
                    distanceMatrix[i - 1][j] + 1, // Delete
                    distanceMatrix[i - 1][j - 1] + indicator // Replace
                );
            }
        }

        return distanceMatrix[string1.length][string2.length];
    }


    // Fonction pour calculer la similitude entre deux chaînes de caractères
    // ajouter un poids suivant la longueur de la chaine
    const calculateSimilarity = (string1, string2) => {
        // Mettre les deux chaînes en minuscules
        string1 = string1.toLowerCase();
        string2 = string2.toLowerCase();

        // Calculer la distance de Levenshtein
        const distance = levenshteinDistance(string1, string2);

        // Calculer la longueur de la chaîne la plus longue
        const length = Math.max(string1.length, string2.length);

        // Calculer la similitude
        const similarity = (1 - distance / length) * 100;

        return { similarity, distance };
        
    }

    const getAdherent = () => {
        if (code && code !== '')
            fetch(`${url}getAdherentForTribu/${annee}/${code}`)
                .then(response => response.json())
                .then(data => {
                    if (data === '0' || !data.data)
                        gotoAuth();
                    else {
                        // Traiter la réponse si nécessaire
                        let adh = cleanJson(data.data).filter(e=> e.merged===0 && e.has_tribu===1);
                        setAdherents(adh);
                        setDataFiltered(adh);


                    }
                })
                .catch(error => console.error('Erreur:', error));
    };

    useEffect(() => {
        getTribu();
        getAdherent();
    }, [annee]);


    useEffect(() => {
        setDataFiltered(adherents);
    }, [adherents]);


    const filtre = (value, data) => {
        setSearchText(value);
        if (value.length < 1) {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => {
                // must contains all word of value

                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, adherents);
    };

    const handleClose = () => setShow(false);

    const handleShow = (row) => {
        setAdherentSel(row);
        setShowTribu(true);
    }

    const appair = (crm, tribu) => {
        console.log('Appair', crm, tribu);
        //fait un post qui contient adherent_id, identifiant_tribu, garage_id, mail
        fetch(`${url}Appair/${code}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ adherent_id: crm.a_id, identifiant_tribu: tribu.login, garage_id: tribu.id, mail: tribu.mail }),
        })
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0')
                    alert('Erreur de connexion');
                else {
                    getAdherent();
                    console.log('Appairé');
                    setShowTribu(false);
                }
            })
            .catch(error => {
                console.error('Erreur lors de la requête:', error);
            });
        
    }

    const columnsSel = ['a_id', 't_id', 'nom_de_l_entreprise', 'adresse1', 'code_postal', 'ville', 'e_mail_1', 'e_mail_2', 'reseau', 'identifiant_tribu', 'has_tribu', 'merged'];
    // const [columns, setColumns] = useState([]);

    const [columns, setColumns] = useState([]);

    const handleRowClick = (row) => {
        console.log('Ligne cliquée :', row);
        // Faites ce que vous voulez avec la ligne cliquée ici
        handleShow(row);
    };

    const uniqueNetworks = [...new Set(adherents.map(row => row.reseau))].sort();
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const handleNetworkFilter = (network) => {
        setSelectedFeuille('');
        setSelectedNetwork(network);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (network === '') {
            setDataFiltered(adherents);
        } else {
            const filtered = adherents.filter(item => item.reseau === network);
            console.log(filtered)
            setDataFiltered(filtered);
        }
    };

    const uniqueFeuilles = [...new Set(adherents.map(row => row.reference))].sort();
    const [selectedFeuille, setSelectedFeuille] = useState('');
    const handleFeuilleFilter = (feuille) => {
        setSelectedNetwork('');
        setSelectedFeuille(feuille);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (feuille === '') {
            setDataFiltered(adherents);
        } else {
            const filtered = adherents.filter(item => item.reference === feuille);
            console.log(filtered);
            setDataFiltered(filtered);
        }
    };

    const surligneTousLesMotsIdentiques = (phraseASurligner, phraseAcomparer) => {
        //pour chaque mot de phraseAcomparer, surligner tous les mots identiques dans phraseASurligner
        //mettre tout en lowercase
        //ou null ou undefined
        if (!phraseAcomparer || phraseAcomparer === '' || !phraseASurligner || phraseASurligner==='' || phraseAcomparer.length < 2 || phraseASurligner.length < 2 || 
            phraseAcomparer === 'null' || phraseAcomparer === 'undefined' || phraseASurligner === 'null' || phraseASurligner === 'undefined'

         ) return phraseASurligner;

        //remplace tous les caraterer a accent sans accent et tous les ponctuation par un espace
        phraseAcomparer = phraseAcomparer.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, ' ');
        phraseASurligner = phraseASurligner.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, ' ');

        let mots = phraseAcomparer.split(' ');
        console.log(mots);  
        let phrase = phraseASurligner;
        mots.forEach(mot => {
            if (mot && phrase && mot.length > 1){
                // console.log(mot, phrase);
                phrase = phrase.replaceAll(mot, `<span style="background-color: yellow;">${mot}</span>`);
            }
        });
        return phrase;
    }

    const AppairHighestPossibility = () => {        
        adherents.forEach(adherent => {
            const similarities = getFiveHighestSimilarities(adherent);
            if (similarities[0].similarity > 70) {
                appair(adherent, similarities[0].garage);
            }
        });
        getAdherent();
    }

    return (
        <div>
            {/* button appairhighest.. */}
            <Button onClick={AppairHighestPossibility}>Appairer les plus probables</Button>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                <h1 style={{ marginLeft: '10px' }}>Export</h1>
                <div style={{ flexGrow: 1 }} />
                <ColumnChooser columnsName={columnsSel} data={dataFiltered} setColumns={setColumns} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ flexGrow: 1 }} />
                <h3 style={{ marginLeft: '10px' }}>{selectedNetwork}</h3>
                <div style={{ flexGrow: 1 }} />
                <Form.Select style={{ width: '300px' }} onChange={(e) => handleNetworkFilter(e.target.value)} value={selectedNetwork}>
                    <option key="reseauVide" value="">Tous les réseaux</option>
                    {uniqueNetworks.map((network, index) => <option key={index + '-' + network} value={network}>{network}</option>)}
                </Form.Select>

            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {/* <h1 style={{ marginLeft: '10px' }}>Adhésion</h1> */}
                <div style={{ flexGrow: 1 }} />
                <h3 style={{ marginLeft: '10px' }}>{selectedFeuille}</h3>
                <div style={{ flexGrow: 1 }} />
                <Form.Select style={{ width: '300px' }} onChange={(e) => handleFeuilleFilter(e.target.value)} value={selectedFeuille}>
                    <option key="feuilleVide" value="">Toutes les feuilles</option>
                    {uniqueFeuilles.map((feuille, index) => <option key={index + '-' + feuille} value={feuille}>{feuille}</option>)}
                </Form.Select>

            </div>
            <DataTable
                columns={columns}
                data={dataFiltered}
                pagination={true}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                subHeader
                subHeaderComponent={(
                    // <div style={{ display: 'flex', alignItems: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                        <input
                            type="text"
                            value={searchText}
                            onChange={handleChangesearchText}
                            // onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Rechercher..."
                        />
                        {searchText && <FaTimes className='h-5' onClick={() => filtre('', adherents)} />}
                        <div style={{ flexGrow: 1 }} />
                        <GenereCsv data={dataFiltered} fichier="Adherent" visible={true} />
                    </div>
                )}
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                paginationComponentOptions={{
                    rowsPerPageText: 'Lignes par page:',
                }}
                onRowClicked={handleRowClick}
            />

            <Modal size="xl" show={show} onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <InfoComplete adherentLight={adherentSel} />
                </Modal.Body>
            </Modal>
            <Modal size="xl" show={showTribu} onHide={() => setShowTribu(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <table width={'100%'}>
                        <thead>
                            <tr>
                                <th>Garage</th>
                                <th>Adresse</th>
                                <th>Mail</th>
                                <th>Réseau</th>
                                <th>Login</th>
                                <th>Similitude</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* adherent  */}
                            <tr>
                                <th>{adherentSel.nom_de_l_entreprise}</th>
                                <th>{adherentSel.adresse1}<br />{adherentSel.code_postal} {adherentSel.ville}</th>
                                <th>{adherentSel.e_mail_1} <br /> {adherentSel.e_mail_2}</th>
                                <th>{adherentSel.reseau}</th>
                                <th>{adherentSel.identifiant_tribu}</th>
                                <th>{adherentSel.has_tribu}</th>
                            </tr>
                            {getFiveHighestSimilarities(adherentSel).map((similarity, index) => (
                                // onclick exec appair (adherentSel, similarity.garage)
                                <tr key={index} onClick={() => appair(adherentSel, similarity.garage)}>
                                    {/* dans innerHtml */}
                                    <td dangerouslySetInnerHTML={{ __html: surligneTousLesMotsIdentiques(similarity.garage.nom, joinAllValueOfAnOBjectSeparatedBySpace(adherentSel)) }}></td>
                                    <td dangerouslySetInnerHTML={{ __html: surligneTousLesMotsIdentiques(similarity.garage.adresse + '<br />' + similarity.garage.cp + ' ' + similarity.garage.ville, joinAllValueOfAnOBjectSeparatedBySpace(adherentSel)) }}></td>

                                    <td dangerouslySetInnerHTML={{ __html: surligneTousLesMotsIdentiques(similarity.garage.mail, joinAllValueOfAnOBjectSeparatedBySpace(adherentSel)) }}></td>
                                    <td dangerouslySetInnerHTML={{ __html: surligneTousLesMotsIdentiques(similarity.garage.reseau, joinAllValueOfAnOBjectSeparatedBySpace(adherentSel)) }}></td>
                                    <td dangerouslySetInnerHTML={{ __html: surligneTousLesMotsIdentiques(similarity.garage.login, joinAllValueOfAnOBjectSeparatedBySpace(adherentSel)) }}></td>
                                    <td align='right'>{similarity.similarity}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </Modal.Body>
            </Modal>
        </div>
    );
}

export default TribuRappro;
